import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Convenio } from '../../../_models/convenio';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { ConvenioService } from '../../../_services/convenio.service';
import { Location } from '@angular/common';

@Component( {
  selector: 'app-convenios-detalle',
  templateUrl: 'convenios-detalle.component.html'
} )
export class ConveniosDetalleComponent implements OnInit {

  //
  model: Convenio = null;


  constructor(
    private router: Router,
    private confirmationService: ConfirmationService,
    private route: ActivatedRoute,
    private convenioService: ConvenioService,
    private location: Location,
  ) {
  }

  ngOnInit() {
    this.route.params.subscribe( ( params: Params ) => {
      if ( (params[ 'id' ] !== '' && params[ 'id' ] !== null && params[ 'id' ] !== undefined) ) {
        this.convenioService.obtenerPorId( params[ 'id' ] ).subscribe( convenio => this.model = convenio );
      } else {
        this.model = null;
      }
    } );

  }

  atras() {
    this.location.back();
  }

}
